/**
 * Which bundle this device is ACTUALLY running.
 *
 * Not a release number. The question that costs time during triage is narrower than that: two crews
 * report the same app behaving differently, and the first thing to establish is whether one of them
 * is still on a build we replaced. On 2026-08-06 that question took a live sheet dump and a diff of
 * the deployed bundle against the source to answer, for what is written on the page the whole time.
 *
 * Read off the loaded script rather than kept in a constant, because a constant is a second thing to
 * remember to bump and the one that is wrong is worse than nothing. The hashed name is generated by
 * the build, so it cannot drift from what is running.
 *
 * ponytail: this identifies the build, not the commit. If the commit is ever wanted, set
 * REACT_APP_BUILD_SHA on the deployment and prefer it over this.
 */
const MAIN_BUNDLE = /\/static\/js\/(main\.[0-9a-zA-Z]+)\.js/;

export function currentBuildId(doc = typeof document === "undefined" ? null : document) {
  if (!doc || typeof doc.querySelectorAll !== "function") return null;
  const scripts = Array.from(doc.querySelectorAll("script[src]"));
  for (const script of scripts) {
    const match = MAIN_BUNDLE.exec(script.getAttribute("src") || "");
    if (match) return match[1];
  }
  // `npm start` serves an unhashed bundle, and so does any host that rewrites asset names. There is
  // no build to name, and naming one anyway is the failure this function exists to prevent.
  return null;
}
